import { FilteringHelper } from '@/helpers/FilteringHelper'
import { ContainerModule } from 'inversify'
import { ActionLogService } from './actionlog/ActionLogService'
import { AuthorisationService } from './authorisation/AuthorisationService'
import { CaseManagementService } from './casemanagement/CaseManagementService'
import { ChargerService } from './charger/ChargerService'
import { DiagnosticService } from './diagnostic/DiagnosticService'
import { FirmwareService } from './firmware/FirmwareService'
import { KpiService } from './kpi/KpiService'
import { LocalControllerService } from './localcontroller/LocalControllerService'
import { ManufacturerService } from './manufacturer/ManufacturerService'
import { PermissionChecker } from './permissions/PermissionChecker'
import { ChargerRealTimeEventService } from './RealTimeEvents/ChargerRealTimeEventService'
import { CommandRealTimeEventService } from './RealTimeEvents/CommandRealTimeEventService'
import { ConnectorRealTimeEventService } from './RealTimeEvents/ConnectorRealTimeEventService'
import { LocalControllerRealTimeEventService } from './RealTimeEvents/LocalControllerRealTimeEventService'
import { SessionRealTimeEventService } from './RealTimeEvents/SessionRealTimeEventService'
import { SERVICES_TYPES } from './ServicesTypes'
import { SessionService } from './session/SessionService'
import { ChargingSiteService } from './site/ChargingSiteService'
import { UserManagementService } from './usermanagement/UserManagementService'
import { WorkOrderService } from './workorder/WorkOrderService'
import { PowerBIService } from './powerbi/PowerBIService'
import { LoyaltyService } from './loyalty/LoyaltyService'

export const serviceContainerModule = new ContainerModule(({ bind }) => {
  bind(SERVICES_TYPES.SiteType).to(ChargingSiteService)
  bind(SERVICES_TYPES.LocalControllerService).to(LocalControllerService)
  bind(SERVICES_TYPES.ChargerService).to(ChargerService)
  bind(SERVICES_TYPES.ActionLogService).to(ActionLogService)
  bind(SERVICES_TYPES.KpiService).to(KpiService)
  bind(SERVICES_TYPES.FilteringHelper).to(FilteringHelper)
  bind(SERVICES_TYPES.PermissionChecker).to(PermissionChecker).inSingletonScope()
  bind(SERVICES_TYPES.LocalControllerRealTimeEvent)
    .toDynamicValue(() => new LocalControllerRealTimeEventService('local-controller'))
    .inSingletonScope()
  bind(SERVICES_TYPES.ChargerRealTimeEvent)
    .toDynamicValue(() => new ChargerRealTimeEventService('charger'))
    .inSingletonScope()
  bind(SERVICES_TYPES.ConnectorRealTimeEvent)
    .toDynamicValue(() => new ConnectorRealTimeEventService('connector'))
    .inSingletonScope()
  bind(SERVICES_TYPES.CommandRealTimeEvent)
    .toDynamicValue(() => new CommandRealTimeEventService('command'))
    .inSingletonScope()
  bind(SERVICES_TYPES.SessionRealTimeEvent)
    .toDynamicValue(() => new SessionRealTimeEventService('session'))
    .inSingletonScope()
  bind(SERVICES_TYPES.CaseManagementService).to(CaseManagementService)
  bind(SERVICES_TYPES.SessionService).to(SessionService)
  bind(SERVICES_TYPES.AuthorisationService).to(AuthorisationService)
  bind(SERVICES_TYPES.WorkOrderService).to(WorkOrderService)
  bind(SERVICES_TYPES.UserManagementService).to(UserManagementService)
  bind(SERVICES_TYPES.DiagnosticService).to(DiagnosticService)
  bind(SERVICES_TYPES.FirmwareService).to(FirmwareService)
  bind(SERVICES_TYPES.ManufacturerSerice).to(ManufacturerService)
  bind(SERVICES_TYPES.PowerBIService).to(PowerBIService)
  bind(SERVICES_TYPES.LoyaltyService).to(LoyaltyService)
})
